/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  HangarAllInventoryStockParams,
  HangarInventoryStockItem,
  InventoryStockPosition,
  InventoryStockPositionInput,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Hangar Inventory Stock
 */
export const hangarInventoryStock = (
    hangarInventorySlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      hangarInventorySlug = toValue(hangarInventorySlug);

      return axiosClient<HangarInventoryStockItem[]>(
      {url: `/hangar/inventories/${hangarInventorySlug}/stock`, method: 'GET', signal
    },
      );
    }




export const getHangarInventoryStockQueryKey = (hangarInventorySlug: MaybeRefOrGetter<string>,) => {
    return [
    'hangar','inventories',hangarInventorySlug,'stock'
    ] as const;
    }


export const getHangarInventoryStockQueryOptions = <TData = Awaited<ReturnType<typeof hangarInventoryStock>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(hangarInventorySlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarInventoryStock>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarInventoryStockQueryKey(hangarInventorySlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarInventoryStock>>> = ({ signal }) => hangarInventoryStock(hangarInventorySlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(hangarInventorySlug) !== null && toValue(hangarInventorySlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarInventoryStock>>, TError, TData>
}

export type HangarInventoryStockQueryResult = NonNullable<Awaited<ReturnType<typeof hangarInventoryStock>>>
export type HangarInventoryStockQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Hangar Inventory Stock
 */

export function useHangarInventoryStock<TData = Awaited<ReturnType<typeof hangarInventoryStock>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 hangarInventorySlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarInventoryStock>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarInventoryStockQueryOptions(hangarInventorySlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Hangar Inventory Stock Position
 */
export const hangarInventoryStockItem = (
    hangarInventorySlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      hangarInventorySlug = toValue(hangarInventorySlug);
slug = toValue(slug);

      return axiosClient<InventoryStockPosition>(
      {url: `/hangar/inventories/${hangarInventorySlug}/stock/${slug}`, method: 'GET', signal
    },
      );
    }




export const getHangarInventoryStockItemQueryKey = (hangarInventorySlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,) => {
    return [
    'hangar','inventories',hangarInventorySlug,'stock',slug
    ] as const;
    }


export const getHangarInventoryStockItemQueryOptions = <TData = Awaited<ReturnType<typeof hangarInventoryStockItem>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(hangarInventorySlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarInventoryStockItem>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarInventoryStockItemQueryKey(hangarInventorySlug,slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarInventoryStockItem>>> = ({ signal }) => hangarInventoryStockItem(hangarInventorySlug,slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(hangarInventorySlug) !== null && toValue(hangarInventorySlug) !== undefined && toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarInventoryStockItem>>, TError, TData>
}

export type HangarInventoryStockItemQueryResult = NonNullable<Awaited<ReturnType<typeof hangarInventoryStockItem>>>
export type HangarInventoryStockItemQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Hangar Inventory Stock Position
 */

export function useHangarInventoryStockItem<TData = Awaited<ReturnType<typeof hangarInventoryStockItem>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 hangarInventorySlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarInventoryStockItem>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarInventoryStockItemQueryOptions(hangarInventorySlug,slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Hangar Inventory Stock Position
 */
export const updateHangarInventoryStockItem = (
    hangarInventorySlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
    inventoryStockPositionInput: MaybeRefOrGetter<InventoryStockPositionInput>,
 signal?: AbortSignal
) => {
      hangarInventorySlug = toValue(hangarInventorySlug);
slug = toValue(slug);
inventoryStockPositionInput = toValue(inventoryStockPositionInput);

      return axiosClient<InventoryStockPosition>(
      {url: `/hangar/inventories/${hangarInventorySlug}/stock/${slug}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: inventoryStockPositionInput, signal
    },
      );
    }




export const getUpdateHangarInventoryStockItemMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHangarInventoryStockItem>>, TError,{hangarInventorySlug: string;slug: string;data: InventoryStockPositionInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateHangarInventoryStockItem>>, TError,{hangarInventorySlug: string;slug: string;data: InventoryStockPositionInput}, TContext> => {

const mutationKey = ['updateHangarInventoryStockItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHangarInventoryStockItem>>, {hangarInventorySlug: string;slug: string;data: InventoryStockPositionInput}> = (props) => {
          const {hangarInventorySlug,slug,data} = props ?? {};

          return  updateHangarInventoryStockItem(hangarInventorySlug,slug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHangarInventoryStockItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateHangarInventoryStockItem>>>
    export type UpdateHangarInventoryStockItemMutationBody = InventoryStockPositionInput
    export type UpdateHangarInventoryStockItemMutationError = ErrorType<ValidationError | StandardError>

    /**
 * @summary Update Hangar Inventory Stock Position
 */
export const useUpdateHangarInventoryStockItem = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHangarInventoryStockItem>>, TError,{hangarInventorySlug: string;slug: string;data: InventoryStockPositionInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateHangarInventoryStockItem>>,
        TError,
        {hangarInventorySlug: string;slug: string;data: InventoryStockPositionInput},
        TContext
      > => {
      return useMutation(getUpdateHangarInventoryStockItemMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete Hangar Inventory Stock Position
 */
export const destroyHangarInventoryStockItem = (
    hangarInventorySlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      hangarInventorySlug = toValue(hangarInventorySlug);
slug = toValue(slug);

      return axiosClient<void>(
      {url: `/hangar/inventories/${hangarInventorySlug}/stock/${slug}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyHangarInventoryStockItemMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyHangarInventoryStockItem>>, TError,{hangarInventorySlug: string;slug: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyHangarInventoryStockItem>>, TError,{hangarInventorySlug: string;slug: string}, TContext> => {

const mutationKey = ['destroyHangarInventoryStockItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyHangarInventoryStockItem>>, {hangarInventorySlug: string;slug: string}> = (props) => {
          const {hangarInventorySlug,slug} = props ?? {};

          return  destroyHangarInventoryStockItem(hangarInventorySlug,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyHangarInventoryStockItemMutationResult = NonNullable<Awaited<ReturnType<typeof destroyHangarInventoryStockItem>>>

    export type DestroyHangarInventoryStockItemMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Delete Hangar Inventory Stock Position
 */
export const useDestroyHangarInventoryStockItem = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyHangarInventoryStockItem>>, TError,{hangarInventorySlug: string;slug: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyHangarInventoryStockItem>>,
        TError,
        {hangarInventorySlug: string;slug: string},
        TContext
      > => {
      return useMutation(getDestroyHangarInventoryStockItemMutationOptions(options), queryClient);
    }
    /**
 * @summary Hangar All Inventory Stock
 */
export const hangarAllInventoryStock = (
    params?: MaybeRefOrGetter<HangarAllInventoryStockParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<HangarInventoryStockItem[]>(
      {url: `/hangar/inventory-stock`, method: 'GET',
        params, signal
    },
      );
    }




export const getHangarAllInventoryStockQueryKey = (params?: MaybeRefOrGetter<HangarAllInventoryStockParams>,) => {
    return [
    'hangar','inventory-stock', ...(params ? [params] : [])
    ] as const;
    }


export const getHangarAllInventoryStockQueryOptions = <TData = Awaited<ReturnType<typeof hangarAllInventoryStock>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<HangarAllInventoryStockParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarAllInventoryStock>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarAllInventoryStockQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarAllInventoryStock>>> = ({ signal }) => hangarAllInventoryStock(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarAllInventoryStock>>, TError, TData>
}

export type HangarAllInventoryStockQueryResult = NonNullable<Awaited<ReturnType<typeof hangarAllInventoryStock>>>
export type HangarAllInventoryStockQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Hangar All Inventory Stock
 */

export function useHangarAllInventoryStock<TData = Awaited<ReturnType<typeof hangarAllInventoryStock>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<HangarAllInventoryStockParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarAllInventoryStock>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarAllInventoryStockQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






